import './App.css';
import * as React from "react";
import { BrowserRouter } from 'react-router-dom'
import AppRouter from './routes';
import { checkForUpdates } from './utils/versionCheck';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App({ children }) {
   // Uygulama açıldığında version kontrolü yap
   React.useEffect(() => {
      checkForUpdates();
   }, []);

   return (
      <div className="App">
         <BrowserRouter>
            <div className="flex flex-col">
               <AppRouter />
            </div>
         </BrowserRouter>
         <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
         />
      </div>
   )
}

export default App
